<div class="w-100">
  <span style="font-weight: 700;">downloading ({{value}}) file(s) ... this may take a while </span>
  <div class="container p-0">
    <div class="skills html" [style.width]="widthCss"></div>
  </div>
</div>